import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardRankingMultiColumnDefinition } from './create-dashboard-ranking-multi-column-definition';
import {
  RankingMultiColumnMetricProfile,
  rankingMultiColumnCompaniesCountProfile,
  rankingMultiColumnCompaniesRevenueProfile,
  rankingMultiColumnEconomicParticipantProfile,
  rankingMultiColumnEmployedProfile,
  rankingMultiColumnGrossValueAddedProfile,
} from './dashboard-ranking-multi-column-metric.profile';
import { DashboardRankingMultiColumnShell } from './dashboard-ranking-multi-column-shell.profile';
import { DashboardRankingMultiColumnDefinition } from './dashboard-ranking-multi-column.definition';

/**
 * Product catalog for Ranking × WzClasses multi-column dashboards.
 * Identity is derived in {@link createDashboardRankingMultiColumnDefinition}.
 */

type RankingMultiColumnMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed
>;

export const RANKING_MULTI_COLUMN_PRODUCT_CATALOG: Record<
  RankingMultiColumnMetric,
  ProductCatalogEntry<
    RankingMultiColumnMetricProfile,
    DashboardRankingMultiColumnShell
  >
> = {
  [Metric.CompaniesCount]: {
    metric: rankingMultiColumnCompaniesCountProfile,
    shells: ['wzClasses'],
  },
  [Metric.CompaniesRevenue]: {
    metric: rankingMultiColumnCompaniesRevenueProfile,
    shells: ['wzClasses'],
  },
  [Metric.GrossValueAdded]: {
    metric: rankingMultiColumnGrossValueAddedProfile,
    shells: ['wzClasses'],
  },
  [Metric.EconomicParticipant]: {
    metric: rankingMultiColumnEconomicParticipantProfile,
    shells: ['wzClasses'],
  },
  [Metric.Employed]: {
    metric: rankingMultiColumnEmployedProfile,
    shells: ['wzClasses'],
  },
};

/** All Ranking × WzClasses multi-column product definitions. */
export const RANKING_MULTI_COLUMN_DEFINITIONS: DashboardRankingMultiColumnDefinition[] =
  expandProductCatalog(
    Object.values(RANKING_MULTI_COLUMN_PRODUCT_CATALOG),
    createDashboardRankingMultiColumnDefinition,
  );
